export const COMPANY = {
  name: "FutureLiving Home Buyers",
  phoneDisplay: "(773) 809-4195",
  phoneHref: "tel:+17738094195",
  email: "Offers@futurelivingusa.com",
  serviceArea: "Nationwide",
};
